import Vue from 'vue'
import VueRouter from 'vue-router'

import AboutUs from '@/pages/about-us/about-us'
import Contact from '@/pages/contact/contact'
import GettingStarted from '@/pages/getting-started/getting-started'
import Home from '@/pages/home/home'
import Treatments from '@/pages/treatments/treatments'
import AccessibilityStatement from '@/pages/accessibility-statement/accessibility-statement'
// const AboutUs = () => import(/* webpackChunkName: "group" */ '@/pages/about-us/about-us')

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      linkName: 'HOME',
      iconName: 'home',
      navigation: false,
      mobile: true,
      component: Home
    },
    {
      path: '/about-us',
      name: 'about-us',
      linkName: 'ABOUT US',
      iconName: 'aboutus',
      navigation: true,
      component: AboutUs
    },
    {
      path: '/getting-started',
      name: 'getting-started',
      linkName: 'GETTING STARTED',
      iconName: 'gettingstarted',
      navigation: true,
      component: GettingStarted
    },
    {
      path: '/treatments',
      name: 'treatments',
      linkName: 'TREATMENTS',
      iconName: 'treatments',
      navigation: true,
      component: Treatments
    },
    {
      path: '/contact',
      name: 'contact',
      linkName: 'CONTACT',
      iconName: 'contactus',
      navigation: true,
      component: Contact
    },
    {
      path: '/accessibility-statement',
      name: 'Accessibility Statement',
      linkName: 'AccessibilityStatement',
      iconName: 'AccessibilityStatement',
      navigation: false,
      component: AccessibilityStatement
    },
    {
      path: '/*',
      name: 'redirect',
      navigation: false,
      component: Home
    }
  ]
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js